(ns ui.gallery.register
  "UI register of the gallery slice: the Replicant gallery page under
   /ui/gallery, its modals and action handlers. The sidebar links the
   route and `/#/gallery` redirects to it."
  (:require [ui.gallery.actions :as actions]
            [ui.gallery.confirm-modal :as confirm-modal]
            [ui.gallery.entry-modal :as entry-modal]
            [ui.gallery.page :as page]
            [ui.gallery.prompt-modal :as prompt-modal]))

(def register
  (concat [page/page
           entry-modal/modal
           prompt-modal/modal
           confirm-modal/modal]
          actions/handlers))
